var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPagearrowleft(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.362 6.889a1.267 1.267 0 010-1.777L5.035.368a1.23 1.23 0 011.754 0 1.267 1.267 0 010 1.78L4.23 4.742h9.53c.328 0 .644.133.876.368a1.267 1.267 0 010 1.778 1.23 1.23 0 01-.876.369H4.23l2.558 2.595a1.259 1.259 0 01.363.89 1.274 1.274 0 01-.363.889 1.239 1.239 0 01-.877.368 1.224 1.224 0 01-.877-.368L.362 6.889z",
    fill: "#2A848E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagearrowleft);
export default ForwardRef;